import { pick } from 'lodash'
import { track } from '../analytics'

const getArgs = args => {
  return pick(args, ['workspaceId', 'workspaceSlug'])
}

export const personasGeneratedAccessToken = args => {
  track('Personas Generated Access Token', getArgs(args))
}
